export const UID = {
  STRIPE: "stripe",
  PRICEBLOCS: "priceblocs"
};

export const getColumns = ({ header, subheader }) => [
  {
    header,
    subheader,
    accessor: "title"
  },
  {
    accessor: UID.STRIPE
  },
  {
    accessor: UID.PRICEBLOCS
  }
];
